module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/safari-pinned-tab-24071e8b20c91109cfb0347f4c3d09af.svg";